export default {
  generateHtml (head = {title: ''}, data, inHead, inBody) {
    return `
    <!DOCTYPE html>
    <html>
      <head>
        <meta charset="utf-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0">
        <meta name="description" content="">
        <meta name="keyword" content="">
        <link rel="icon" type="image/png" sizes="32x32" href="https://static001.geekbang.org/static/www/img/favicon-96x96.8e64510.png">
        <script type="text/javascript" src="https://res.wx.qq.com/open/js/jweixin-1.0.0.js"></script>
        <!-- Global site tag (gtag.js) - Google Analytics -->
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-109614010-1"></script>
        <script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'UA-103082599-1');</script>
        <title>${head.title || 'Hello'} | Geekbang</title>
        ${inHead}
        <script>window.GEEKBANG_DATA=${data}</script>
      </head>
      <body>
        <div id="app"></div>
        ${inBody}
      </body>
      </html>
    `
  }
}
